module.exports = __webpack_public_path__ + "media/components/buttons/static/surf-forecast__logo-4323570e0b23f1102af0100ddb852c0a.svg";